import { BorderOutlined } from "@ant-design/icons";
import { spacerCore } from "./core/spacer";
import { defineWidget } from "../widgetDefinition";
import { NoSlots } from "../Slots";
import { NoControlPanel, NoDuplication, NoInfo } from "../widgetContract";
import type { SpacerComponentSpec } from "../Processing/types";
import { SpacerWidget } from "../WidgetComponents/SpacerWidget";

export const spacerDefinition = defineWidget<SpacerComponentSpec>({
  ...spacerCore,
  type: "spacer",
  slots: NoSlots,
  duplicate: NoDuplication,
  controlPanel: NoControlPanel,
  info: NoInfo,
  schema: [],
  contractHash: "1x2fucpqnd8",

  template: {
    label: "Spacer",
    description: "Empty white space for layout spacing",
    icon: <BorderOutlined />,
  },

  defaultLayout: { w: 6, h: 3, minW: 1, minH: 1 },

  gridComponent: ({ id }) => <SpacerWidget id={id} />,
});
